import React from "react";
import { motion } from "framer-motion";

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
    else el.scrollIntoView({ behavior: "smooth" });
};

export const GemMark = ({ size = 30 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <g stroke="#D4AF37" strokeWidth="2.6" strokeLinejoin="round" fill="none">
            <path d="M32 9 L53 32 L32 55 L11 32 Z" />
            <path d="M32 21 L41 32 L32 43 L23 32 Z" stroke="#E6C687" strokeWidth="2.2" />
        </g>
        <circle cx="32" cy="32" r="2.4" fill="#D4AF37" />
    </svg>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 30 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);
